import styled from 'styled-components';

/**
 * KeepCase — exempts a brand word from an ancestor's `text-transform:
 * lowercase` (2026-08-21 owner directive: "Prest0n is always uppercase
 * because it's a name" — the house lowercase idiom must not downcase it).
 *
 * Usage: <KeepCase>Prest0n</KeepCase> inside any lowercase-transformed copy.
 * Author the brand word in its true case; everything around it keeps the
 * page's lowercase rendering.
 */
const KeepCase = styled.span`
  text-transform: none;
`;

export default KeepCase;
